// 订单充电过程
import React, { Component } from "react";
import { Radio } from "antd";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import "@/assets/stylus/com/display/process.styl";
import PropsType from "prop-types";
import StubChargeCourse from "./stubChargeCourse";
import PowerMoudleChargeCourse from "./powerMoudleChargeCourse";

@connect((state) => state)
class OrderChargeCourse extends Component {
  constructor(props) {
    super(props);
    this.init();
    this.props = props;
    this.internationalization = this.props.intl.messages.orderChargeCourse;
    this.state = {
      currentPhase: "stub",
    };
  }

  init() {
    this.query = {
      page: "1",
      pagecount: "10",
    };
    // this.query['orderId'] = '202004041900040516';
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["orderId"] = window.LayoutTab.tabParam.orderId;
    }
  }

  componentDidMount() {
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["orderId"] = window.LayoutTab.tabParam.orderId;
    }
  }

  handleModuleTypeChange = (e) => {
    this.setState({
      currentPhase: e.target.value,
    });
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div>
          <Radio.Group
            defaultValue="stub"
            buttonStyle="solid"
            onChange={this.handleModuleTypeChange}>
            <Radio.Button value="stub">{this.internationalization.title1}</Radio.Button>
            <Radio.Button value="power">{this.internationalization.title2}</Radio.Button>
          </Radio.Group>

          <hr />
          {this.state.currentPhase === "stub" ? (
            <StubChargeCourse params={this.query}></StubChargeCourse>
          ) : (
            <PowerMoudleChargeCourse
              params={this.query}
              moduleChartType="1">
            </PowerMoudleChargeCourse>
          )}
        </div>
      </div>
    );
    return Content;
  }
}

export default injectIntl(OrderChargeCourse);

OrderChargeCourse.propsType = {
  onAdd: PropsType.func,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/orderChargeCourse.js